import { connect } from 'react-redux'
import DeviceChip from './DeviceChip'
import { getPeeCeeVariantLabel } from '../../../hooks/useBrandConfig'
import { getDeviceName } from '../../../utils/utils'


function DeviceMissMatchPopupCom(props) {
    const mismatched = props?.device?.deviceMismatched || {}

    // ── Unsupported firmware: PeeCee below the minimum required version ────
    if (mismatched.firmwareUnsupported) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <p
                    style={{
                        margin: 0,
                        fontSize: '2.3vh',
                        fontWeight: 700,
                        color: '#333',
                    }}
                >
                    Firmware update required
                </p>
                <p
                    style={{
                        margin: '0.4rem 0 1.2rem',
                        fontSize: '1.8vh',
                        color: '#666',
                    }}
                >
                    This firmware version is no longer supported. Please
                    update to the latest firmware to continue.
                </p>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.9rem',
                        width: '100%',
                    }}
                >
                    <DeviceChip
                        label="Current Version"
                        value={mismatched.currentVersion}
                        highlight
                    />
                    <span
                        style={{
                            fontSize: '1.4rem',
                            color: '#f97d62',
                        }}
                    >
                        →
                    </span>
                    <DeviceChip
                        label="Required Version"
                        value={`${mismatched.minFirmware}+`}
                    />
                </div>
            </div>
        )
    }

    // ── Variant mismatch: PeeCee Ted 1 ↔ Ted 2 ──────────────────────────────
    if (mismatched.variantMismatch) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <p
                    style={{
                        margin: 0,
                        fontSize: '2.3vh',
                        fontWeight: 700,
                        color: '#333',
                    }}
                >
                    A device mismatch found!
                </p>
                <p
                    style={{
                        margin: '0.4rem 0 1.2rem',
                        fontSize: '1.8vh',
                        color: '#666',
                    }}
                >
                    Would you like to continue with the connected device?
                </p>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.9rem',
                        width: '100%',
                    }}
                >
                    <DeviceChip label="Selected Device" value={mismatched.selected} />
                    <span
                        style={{
                            fontSize: '1.4rem',
                            color: '#f97d62',
                        }}
                    >
                        →
                    </span>
                    <DeviceChip
                        label="Connected Device"
                        value={mismatched.detected}
                        highlight
                    />
                </div>
            </div>
        )
    }

    // ── Regular device / version mismatch ────────────────────────────────────
    const rawDeviceName =
        props?.device?.connectedDevice ||
        sessionStorage.getItem('connectedDevice') ||
        ''
    let expectedDeviceName = getDeviceName(rawDeviceName) || rawDeviceName
    let expectedDeviceVersion =
        sessionStorage.getItem('deviceVersion') ||
        props?.device?.deviceVersion ||
        ''
    if (expectedDeviceVersion == '0.0.0') {
        expectedDeviceVersion = props?.device?.deviceVersion || ''
    }

    const connectedDeviceName = mismatched.peeCeeVariant
        ? getPeeCeeVariantLabel(mismatched.peeCeeVariant)
        : mismatched.name

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
            }}
        >
            <p
                style={{
                    margin: 0,
                    fontSize: '2.3vh',
                    fontWeight: 700,
                    color: '#333',
                }}
            >
                A device mismatch found!
            </p>
            <p
                style={{
                    margin: '0.4rem 0 1.2rem',
                    fontSize: '1.8vh',
                    color: '#666',
                }}
            >
                Would you like to continue with the connected device?
            </p>

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.9rem',
                    width: '100%',
                }}
            >
                <DeviceChip
                    label="Expected"
                    value={expectedDeviceName}
                    subValue={expectedDeviceVersion}
                />
                <span
                    style={{
                        fontSize: '1.4rem',
                        color: '#f97d62',
                    }}
                >
                    →
                </span>
                <DeviceChip
                    label="Connected"
                    value={connectedDeviceName}
                    subValue={mismatched.version}
                    highlight
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(DeviceMissMatchPopupCom)
